import { render, staticRenderFns } from "./AuthVerify.vue?vue&type=template&id=c4484cba&scoped=true&"
import script from "./AuthVerify.vue?vue&type=script&lang=js&"
export * from "./AuthVerify.vue?vue&type=script&lang=js&"
import style0 from "./AuthVerify.vue?vue&type=style&index=0&id=c4484cba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4484cba",
  null
  
)

export default component.exports